module.exports = __webpack_public_path__ + "static/media/LineAtt.fa6096c5.svg";